import { render, staticRenderFns } from "./AveragePosition.vue?vue&type=template&id=a0617252&scoped=true&"
import script from "./AveragePosition.vue?vue&type=script&lang=js&"
export * from "./AveragePosition.vue?vue&type=script&lang=js&"
import style0 from "./AveragePosition.vue?vue&type=style&index=0&id=a0617252&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0617252",
  null
  
)

export default component.exports